 export const doctors=[
    {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
     {   id:1,
        name:"Dr. Stefen Hawking",
        Age:56,
        Experience:"22+ years",
        Specialist:"Heart Specialist",
        Registered:"01-11-2021",
        Hospitals:["Appolo","Ruby Hospital","Cure & Care","Peerless"],
        Diagonistics:["Welkin","Healthy","Johnsons"],
        
    },
    
 ]